import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { useModal } from "@shortsworks/ui";
import { setAuthToken } from "@shortsworks/user-api";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DEVICE, USER_DEVICE_TYPE } from "@app/types/device";
import { Path } from "@app/route_path";

// device 상태만 cookies 로 관리
export const LoginByApp = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const accessToken = searchParams.get("access_token");
  const refreshToken = searchParams.get("refresh_token");
  const initPage = searchParams.get("init_page");

  // restrict mode 에서 2번 발생하는 점 확인 필요
  useEffect(() => {
    (async () => {
      if (!accessToken || !refreshToken) {
        await showModal(CommonErrorModal, {
          title: "로그인 정보가 옳바르지 않습니다.",
        }).promise();
        return navigate(Path.LOGIN);
      }

      setAuthToken({
        accessToken,
        refreshToken,
      });

      // 클리어가 지장을 줄 수 있음
      sessionStorage.clear();
      sessionStorage.setItem(USER_DEVICE_TYPE, DEVICE.MOBILE);

      if (!initPage) return navigate(Path.DASHBOARD);
      return navigate(initPage);
    })();
  }, []);

  return <></>;
};
